// src/components/Groups/InvitationRow.jsx
import React from 'react';
import { Clock, X, RefreshCw } from 'lucide-react';

const InvitationRow = ({ invitation, onCancel, onResend }) => {
  const target =
    invitation.user_details?.full_name ||
    invitation.user_details?.email ||
    invitation.email ||
    'Unknown';

  const expiresAt = new Date(invitation.expires_at);
  const isExpired = expiresAt < new Date();

  return (
    <div className={`invitation-row ${isExpired ? 'invitation-row--expired' : ''}`}>
      <div className="invitation-row__info">
        <span className="invitation-row__target">{target}</span>
        <span className="invitation-row__role">{invitation.role}</span>
        <span className="invitation-row__expiry">
          <Clock size={12} />
          {isExpired ? 'Expired' : `Expires ${expiresAt.toLocaleDateString()}`}
        </span>
      </div>
      <div className="invitation-row__actions">
        <button
          className="btn btn--sm btn--ghost"
          onClick={() => onResend(invitation.id)}
          title="Resend / extend"
        >
          <RefreshCw size={13} /> Resend
        </button>
        <button
          className="btn btn--sm btn--ghost btn--danger"
          onClick={() => onCancel(invitation.id)}
          title="Cancel invitation"
        >
          <X size={13} /> Cancel
        </button>
      </div>
    </div>
  );
};

export default InvitationRow;
